import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ig-ig-core',
  template: `
    <p>
      ig-core works!
    </p>
  `,
  styles: []
})
export class IgCoreComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
